import React from 'react';
import { Clock, Mail, Shield } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

function PendingApproval() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = location.state?.user;

  if (!user) {
    navigate('/login');
    return null;
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'var(--bg-secondary)',
      padding: '20px'
    }}>
      <div style={{ 
        maxWidth: '600px',
        background: 'white',
        borderRadius: '20px',
        padding: '48px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        <div style={{ 
          width: '100px', 
          height: '100px', 
          margin: '0 auto 32px',
          borderRadius: '25px',
          background: 'hsl(38, 92%, 95%)',
          border: '3px solid var(--warning-500)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Clock size={50} style={{ color: 'var(--warning-600)' }} />
        </div>

        <h1 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '16px' }}>
          Account Pending Approval
        </h1>
        
        <p style={{ fontSize: '1.125rem', color: 'var(--text-secondary)', marginBottom: '32px', lineHeight: '1.6' }}>
          Thank you for signing up, <strong>{user.name}</strong>!
        </p>

        <div style={{ 
          padding: '24px', 
          background: 'hsl(199, 89%, 96%)',
          border: '2px solid var(--info-500)',
          borderRadius: '12px',
          marginBottom: '32px',
          textAlign: 'left'
        }}>
          <h3 style={{ fontSize: '1rem', fontWeight: '700', marginBottom: '12px', color: 'var(--info-700)' }}>
            What happens next?
          </h3>
          <ol style={{ fontSize: '0.9375rem', lineHeight: '1.8', color: 'var(--text-primary)', paddingLeft: '20px' }}>
            <li>An administrator will review your account request</li>
            <li>You'll receive an email notification once approved</li>
            <li>After approval, you can sign in and access the platform</li>
          </ol>
        </div>

        <div style={{ display: 'flex', gap: '16px', fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
          <div style={{ flex: 1, padding: '16px', background: 'var(--bg-secondary)', borderRadius: '10px' }}>
            <Mail size={20} style={{ margin: '0 auto 8px', display: 'block', color: 'var(--primary-500)' }} />
            <p><strong>Email:</strong></p>
            <p>{user.email}</p>
          </div>
          <div style={{ flex: 1, padding: '16px', background: 'var(--bg-secondary)', borderRadius: '10px' }}>
            <Shield size={20} style={{ margin: '0 auto 8px', display: 'block', color: 'var(--accent-500)' }} />
            <p><strong>Status:</strong></p>
            <p style={{ color: 'var(--warning-600)', fontWeight: '600' }}>Pending Approval</p>
          </div>
        </div>

        <button
          onClick={() => navigate('/login')}
          className="btn btn-secondary"
          style={{ marginTop: '32px', width: '100%', justifyContent: 'center' }}
        >
          Return to Login
        </button>
      </div>
    </div>
  );
}

export default PendingApproval;
